import React, { createContext, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { themes } from '../../theme';
import i18n from '../../i18n';

export const LanguageContext = createContext({});

const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState(themes.ltr);

  useEffect(() => {
    const updateTheme = (lng: string) => {
      const direction = lng === 'fa' ? themes.rtl : themes.ltr;
      setTheme(direction);
      document.documentElement.setAttribute('dir', direction.direction);
      document.documentElement.setAttribute('lang', lng);
    };

    updateTheme(i18n.language);
    i18n.on('languageChanged', updateTheme);

    return () => {
      i18n.off('languageChanged', updateTheme);
    };
  }, []);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default LanguageProvider;
